import { useCallback, useState } from 'react';
import { showStyleSwitcher, useTheme } from './theme';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Capabilities from './components/Capabilities';
import { Altitudes, Assurance, DataMarquee, Manifesto, Principles } from './components/Sections';
import Process from './components/Process';
import Contact from './components/Contact';
import Footer from './components/Footer';
import StyleSwitcher from './components/StyleSwitcher';

export default function App() {
  const { theme, mode, phase, setMode } = useTheme();
  const [prefill, setPrefill] = useState(null);
  const startProject = useCallback((email) => setPrefill({ email: email.trim(), at: Date.now() }), []);

  return (
    <div className="site" id="top">
      <a className="skip-link" href="#contact">
        Skip to contact form
      </a>
      <Nav />
      <main>
        <Hero theme={theme} onStart={startProject} />
        <Capabilities />
        <DataMarquee />
        <Principles />
        <Manifesto />
        <Altitudes />
        <Process />
        <Assurance theme={theme} />
        <Contact theme={theme} prefill={prefill} />
      </main>
      <Footer sky={mode === 'auto' ? phase : null} />
      {showStyleSwitcher() && <StyleSwitcher mode={mode} phase={phase} onChange={setMode} />}
    </div>
  );
}
